module.exports = __webpack_public_path__ + "img/expostyle_9662_tomato_pantone_1795c.19555488.jpg";